import { Button, Modal } from 'react-bootstrap'

export default function DeleteCoverModal({ show, onClose, onDelete }) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Cover</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-danger">
          Are you sure you want to delete this book cover?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
